import OwnableTheme from '@Theme';
import { Pressable, StyleSheet } from 'react-native';

import { ElevatorArrowIcon } from './ElevatorArrowIcon';

type Props = {
  direction: 'down' | 'up';
  disabled?: boolean;
  onPress?: () => void;
};

export const ElevatorArrowButton = ({
  direction,
  disabled = false,
  onPress,
}: Props) => {
  const opacity = disabled ? 0.25 : 1;

  const onPressablePress = () => {
    if (!disabled) {
      onPress?.();
    }
  };

  return (
    <Pressable style={[styles.button, { opacity }]} onPress={onPressablePress}>
      <ElevatorArrowIcon direction={direction} size={17} />
    </Pressable>
  );
};

const styles = StyleSheet.create({
  button: {
    width: 32,
    height: 32,
    borderRadius: 16,
    backgroundColor: OwnableTheme.colors.white,
    alignItems: 'center',
    justifyContent: 'center',
  },
});
